import {
    useState,
    forwardRef,
    useImperativeHandle,
    useRef,
} from "react"
import DataElement from "../DataElement"

const CountryFields = forwardRef(({ data, readOnly, attributes, title }, ref) => {

    const dataElementRef = useRef()

    const [error, setError] = useState("")

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {

            const addressAdditionalFieldResult = dataElementRef.current.validateAndGetData()

            const isValid = addressAdditionalFieldResult.isValid

            setError(isValid ? "" : "Please fill the fields correctly.")

            return addressAdditionalFieldResult
        },
    }))

    return (
        <div className="my-4">

            {title && (
                <label className="block text-sm font-medium text-gray-700">{`"${title}" Country Fields`}</label>
            )}

            <DataElement
                ref={dataElementRef}
                attributes={attributes}
                data={data}
                readOnly={readOnly}
            />

            {error && (
                <p className="text-red-600 text-sm mt-2">
                    {error}
                </p>
            )}

        </div>
    )
})

export default CountryFields
